<template>
    <div>
        <NavigationBar/>
        <ManagedCompaniesMenu/>
        <ShareholdersStructure/>
        <ShareholdersDetails/>
        <FooterView/>
    </div>
</template>
<script>
import NavigationBar from "@/components/shared/Navigation-bar.vue";
import FooterView from "@/components/shared/Footer/Footer-view.vue";
import ManagedCompaniesMenu from "@/components/ManagedCompanies/Managed-companies-menu.vue";
import ShareholdersStructure from "@/components/ManagedCompanies/Shareholders-structure.vue"
import ShareholdersDetails from "@/components/ManagedCompanies/Shareholders-details.vue";

export default {
    name: "Managed-Companies.vue",
    components: {ShareholdersDetails, ManagedCompaniesMenu, FooterView, NavigationBar, ShareholdersStructure}
}
</script>

